import { createI18n } from 'vue-i18n'
import en from './en.json'
import vi from './vi.json'

const STORAGE_KEY = 'retiora-locale'
const supportedLocales = ['en', 'vi']
const savedLocale = window.localStorage.getItem(STORAGE_KEY)
const locale = supportedLocales.includes(savedLocale) ? savedLocale : 'en'

const messages = { en, vi }

const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	locale,
	fallbackLocale: 'en',
	messages,
})

export function setLocale(locale) {
	if (!supportedLocales.includes(locale)) return

	i18n.global.locale.value = locale
	window.localStorage.setItem(STORAGE_KEY, locale)
}

export default i18n
